var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.982 8.293a.928.928 0 000 1.414l7.82 7c.437.39 1.144.39 1.58 0l7.821-7a.928.928 0 000-1.414 1.212 1.212 0 00-1.58 0l-7.03 6.293-7.031-6.293a1.212 1.212 0 00-1.58 0z",
    fill: "#222"
  })));
};
export default SvgArrowDown;